// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"120":"ef0296a9","223":"79b5637e"}[chunkId] + ".css";
};